import axios from 'axios';

export const apiInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_EMBEDDED_LENDING_BACKEND}/api`,
});

export default apiInstance;
